import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { SAME_ADDRESS_MAX_MILES } from "../services/distance";

interface FormattedDistanceToPlacementProps {
  id: string | undefined;
  // Wraps the formatted "X miles" value, e.g. with a "Distance:" label.
  renderDistance: (miles: React.ReactNode) => React.ReactElement;
  // Rendered when the placement is essentially at the entered address.
  renderAtThisAddress: () => React.ReactElement;
}

export const FormattedDistanceToPlacement = ({
  id,
  renderDistance,
  renderAtThisAddress,
}: FormattedDistanceToPlacementProps): React.ReactElement | null => {
  const distance = useSelector((state: RootState) => state.distance);

  if (id === undefined) return null;

  const distanceToPlacement = distance?.distanceToPlacementById?.[id];

  // Hide when there is no distance yet or the coordinates produced a
  // non-finite value (e.g. a placement missing lat/lng yields NaN).
  if (
    distanceToPlacement === undefined ||
    !Number.isFinite(distanceToPlacement)
  ) {
    return null;
  }

  if (distanceToPlacement < SAME_ADDRESS_MAX_MILES) {
    return renderAtThisAddress();
  }

  return renderDistance(
    <FormattedMessage
      id="MILES_LABEL"
      values={{ distance: distanceToPlacement }}
    />
  );
};
